/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, RIKEN){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg><img src="/common/images/arrow_left_waku.svg" class="icon" data-view="tablet sp" /></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg><img src="/common/images/arrow_right_waku.svg" class="icon" data-view="tablet sp" /></button>';


	const selectChange = () => {
		$('.js-select').on('change', (e) => {
			let $this = $(e.currentTarget);
			if($this.val() === '') {
				$this.removeClass('is-selected');
			} else {
				$this.addClass('is-selected');
			}
		});
	}

	const householdSelectChange = () => {
		// <入力画面＆エラー画面>
		const dataChange = () => {
			let $inquiryType = $('.js-inquiryType-select').val();
			
			// 電話番号
			if($inquiryType === '商品の不具合に関するお問い合わせ') {
				$('.js-tel').addClass('is-required');
				$('.js-tel .__label').addClass('__required').text('必須');
			} else {
				$('.js-tel').removeClass('is-required');
				$('.js-tel .__label').removeClass('__required').text('任意');	
			}

			// 郵便番号&住所
			if($inquiryType === '商品の不具合に関するお問い合わせ' || $inquiryType === '商品の販売店に関するお問い合わせ') {
				$('.js-zipCode').addClass('is-required');
				$('.js-address').addClass('is-required');
				$('.js-zipCode .__label').addClass('__required').text('必須');
				$('.js-address .__label').addClass('__required').text('必須');
			} else {
				$('.js-zipCode').removeClass('is-required');
				$('.js-address').removeClass('is-required');
				$('.js-zipCode .__label').removeClass('__required').text('任意');	
				$('.js-address .__label').removeClass('__required').text('任意');
			}

			// ご自宅の最寄り駅、お探しの店舗に関するご希望
			if($inquiryType === '商品の販売店に関するお問い合わせ') {
				$('.js-stationName').removeClass('di_none');
				$('.js-request').removeClass('di_none');
			} else {
				$('.js-stationName').addClass('di_none');
				$('.js-request').addClass('di_none');
			}

			// 対象商品の現物の有無、対象商品の賞味期限、購入店舗、購入日
			if($inquiryType === '商品の不具合に関するお問い合わせ') {
				$('.js-actualThing').removeClass('di_none');
				$('.js-expiryYear').removeClass('di_none');
				$('.js-store').removeClass('di_none');
				$('.js-buyYear').removeClass('di_none');
			} else {
				$('.js-actualThing').addClass('di_none');
				$('.js-expiryYear').addClass('di_none');
				$('.js-store').addClass('di_none');
				$('.js-buyYear').addClass('di_none');
			}
		};
		dataChange();
		$('.js-inquiryType-select').on('change', (e) => {
			dataChange();
		});
		// <確認画面>
		if(location.pathname === '/inquiry/contact/household/confirm/' ||
			location.pathname === '/inquiry/contact/household/confirm/index.html') {
			// 選択肢によって「必須」「任意」出し分け =======
			// 電話番号
			let $inquiryType = $('input[name="inquiry_type"][type="hidden"]');
			if($inquiryType.length) {
				if($inquiryType.val() === '商品の不具合に関するお問い合わせ') {
					$('.js-tel').addClass('is-required');
					$('.js-tel .__label').addClass('__required').text('必須');
				}

				// 郵便番号&都道府県&住所
				if($inquiryType.val() === '商品の不具合に関するお問い合わせ' || $inquiryType.val() === '商品の販売店に関するお問い合わせ') {
					$('.js-zipCode').addClass('is-required');
					$('.js-address').addClass('is-required');
					$('.js-zipCode .__label').addClass('__required').text('必須');
					$('.js-address .__label').addClass('__required').text('必須');
				}

				// ご自宅の最寄り駅、お探しの店舗に関するご希望
				if($inquiryType.val() === '商品の販売店に関するお問い合わせ') {
					$('.js-stationName').removeClass('di_none');
					$('.js-request').removeClass('di_none');
				}

				// 対象商品の現物の有無、対象商品の賞味期限、購入店舗、購入日
				if($inquiryType.val() === '商品の不具合に関するお問い合わせ') {
					$('.js-actualThing').removeClass('di_none');
					$('.js-expiryYear').removeClass('di_none');
					$('.js-store').removeClass('di_none');
					$('.js-buyYear').removeClass('di_none');
					// 記入が無い場合は「年月日」削除
					if($('.js-expiryYear td').text().trim() === '年月日') {
						$('.js-expiryYear td').text('');
					}
					if($('.js-buyYear td').text().trim() === '年月日') {
						$('.js-buyYear td').text('');
					}
				}
			}
		}
	};

	// 対象商品の賞味期限
	// その月が何日あるか取得する
	let getDays = (year, month) => {
		return new Date(parseInt(year, 10), parseInt(month, 10), 0).getDate();
	}

	const householdExpiryYear = () => {
		let $nowY = new Date().getFullYear();
		let sessionYear = sessionStorage.getItem('expiry_year');
		let sessiondMonth = sessionStorage.getItem('expiry_month');
		let sessionDate = sessionStorage.getItem('expiry_date');
		let selectedY = sessionYear;
		let selectedM = sessiondMonth;
		let selectedD = sessionDate;
		// $nowY = 2028;

		// 「年」生成
		for(let i = $nowY; i < $nowY +5; i++) {
			if(i == selectedY) {
				$('.js-expiryYear-y').append('<option value="'+ i +'" selected="selected">'+ i +'</option>');
			} else {
				$('.js-expiryYear-y').append('<option value="'+ i +'">'+ i +'</option>');
			}
		}
		// 「月」を生成する
		if($('.js-expiryYear-y').length) {
			// 「月」生成
			for(let i = 1; i <= 12; i++) {
				if(i == sessiondMonth) {
					// 「日」生成
					for(let i = 1; i <= getDays(selectedY, selectedM); i++) {
						if(i == selectedD) {
							$('.js-expiryYear-d').append('<option value="'+ i +'" selected="selected">'+ i +'</option>');
						} else {
							$('.js-expiryYear-d').append('<option value="'+ i +'">'+ i +'</option>');
						}
					}
					$('.js-expiryYear-m').append('<option value="'+ i +'" selected="selected">'+ i +'</option>');
				} else {
					$('.js-expiryYear-m').append('<option value="'+ i +'">'+ i +'</option>');
				}
			}
		};

		// 「年」セレクトで「月」を生成する
		$('.js-expiryYear-y').on('change', (e) => {
			$('.js-expiryYear-m option').remove();
			$('.js-expiryYear-m').append('<option value="">－－</option>');
			$('.js-expiryYear-d option').remove();
			$('.js-expiryYear-d').append('<option value="">－－</option>');
			selectedY = $(e.currentTarget).val();
			sessionStorage.setItem('expiry_year', $(e.currentTarget).val());
			sessionStorage.setItem('expiry_month', '');
			sessionStorage.setItem('expiry_date', '');

			// 「月」生成
			for(let i = 1; i <= 12; i++) {
				$('.js-expiryYear-m').append('<option value="'+ i +'">'+ i +'</option>');
			}
		});

		// 「月」セレクトで「日」を生成する
		$('.js-expiryYear-m').on('change', (e) => {
			$('.js-expiryYear-d option').remove();
			$('.js-expiryYear-d').append('<option value="">－－</option>');
			selectedM = $(e.currentTarget).val();
			sessionStorage.setItem('expiry_month', $(e.currentTarget).val());
			sessionStorage.setItem('expiry_date', '');

			// 「日」生成
			for(let i = 1; i <= getDays(selectedY, selectedM); i++) {
				$('.js-expiryYear-d').append('<option value="'+ i +'">'+ i +'</option>');
			}
		});
		// 「日」をセッションストレージに格納
		$('.js-expiryYear-d').on('change', (e) => {
			sessionStorage.setItem('expiry_date', $(e.currentTarget).val());
		});

		// 入力・確認画面（「入力画面に戻る」から戻った画面）
		if(location.pathname === '/inquiry/contact/household/confirm/' || 
			location.pathname === '/inquiry/contact/household/confirm/index.html') {

		}

	};

	// 購入日
	const householdBuyYear = () => {
		let $dotay = new Date();
		let startM, endM, daysLength;

		// 180日前を取得
		let getOfBeforeAfterDays = function(dateObj, day) {
			let result = false;
			if (dateObj && dateObj.getTime && day && String(day).match(/^-?[0-9]+$/)) {
				result = new Date(dateObj.getTime() + Number(day) * 24 * 60 * 60 * 1000);
			}
			return result;
		};

		let today = new Date();
		let todayY = today.getFullYear();
		let todayM = today.getMonth() + 1;
		let todayD = today.getDate();
		let halfYearAgo = getOfBeforeAfterDays(today, -180);
		let halfYearAgoY = halfYearAgo.getFullYear();
		let halfYearAgoM = halfYearAgo.getMonth() + 1;
		let halfYearAgoD = halfYearAgo.getDate();
		let sessionYear = sessionStorage.getItem('buy_year');
		let sessiondMonth = sessionStorage.getItem('buy_month');
		let sessionDate = sessionStorage.getItem('buy_date');
		let selectedY = sessionYear;
		let selectedM = sessiondMonth;
		let selectedD = sessionDate;


		// 「年」生成
		for(let i = halfYearAgoY; i <= todayY; i++) {
			if(i == sessionYear) {
				$('.js-buyYear-y').append('<option value="'+ i +'" selected="selected">'+ i +'</option>');
			} else {
				$('.js-buyYear-y').append('<option value="'+ i +'">'+ i +'</option>');
			}
		}

		// 「月」を生成する
		if($('.js-buyYear-y').length) {
			if(selectedY == halfYearAgoY) {
				startM = halfYearAgoM;
				endM = 12;
			} else {
				startM = 1;
				endM = todayM;
			}
			// 「月」生成
			for(let i = startM; i <= endM; i++) {
				if(i == sessiondMonth) {
					// 「日」生成
					if(sessiondMonth == todayM) {
						daysLength = todayD;
					} else {
						daysLength = getDays(selectedY, selectedM);
					}

					for(let i = 1; i <= daysLength; i++) {
						if(i == selectedD) {
							$('.js-buyYear-d').append('<option value="'+ i +'" selected="selected">'+ i +'</option>');
						} else {
							$('.js-buyYear-d').append('<option value="'+ i +'">'+ i +'</option>');
						}
					}
					$('.js-buyYear-m').append('<option value="'+ i +'" selected="selected">'+ i +'</option>');
				} else {
					$('.js-buyYear-m').append('<option value="'+ i +'">'+ i +'</option>');
				}
			}
		};

		$('.js-buyYear-y').on('change', (e) => {
			$('.js-buyYear-m option').remove();
			$('.js-buyYear-m').append('<option value="">－－</option>');
			$('.js-buyYear-d option').remove();
			$('.js-buyYear-d').append('<option value="">－－</option>');
			selectedY = $(e.currentTarget).val();
			sessionStorage.setItem('buy_year', $(e.currentTarget).val());
			sessionStorage.setItem('buy_month', '');
			sessionStorage.setItem('buy_date', '');

			if(selectedY == halfYearAgoY) {
				startM = halfYearAgoM;
				endM = 12;
			} else {
				startM = 1;
				endM = todayM;
			}

			// 「月」生成
			for(let i = startM; i <= endM; i++) {
				$('.js-buyYear-m').append('<option value="'+ i +'">'+ i +'</option>');
			}
		});

		// 「月」セレクトで「日」を生成する
		$('.js-buyYear-m').on('change', (e) => {
			$('.js-buyYear-d option').remove();
			$('.js-buyYear-d').append('<option value="">－－</option>');
			selectedM = $(e.currentTarget).val();
			sessionStorage.setItem('buy_month', $(e.currentTarget).val());
			sessionStorage.setItem('buy_date', '');

			if(selectedM == todayM) {
				daysLength = todayD;
			} else {
				daysLength = getDays(selectedY, selectedM);
			}

			// 「日」生成
			for(let i = 1; i <= daysLength; i++) {
				$('.js-buyYear-d').append('<option value="'+ i +'">'+ i +'</option>');
			}
		});
		// 「日」をセッションストレージに格納
		$('.js-buyYear-d').on('change', (e) => {
			sessionStorage.setItem('buy_date', $(e.currentTarget).val());
		});
	};

	// 業務用
	const businessFormDataChange = () => {
		let $inquiryType = $('.js-inquiryType-input').val();
		let $route = $('input[name="route"][checked="checked"]').val();
		// 商品名
		if($inquiryType === '業務用食品') {
			$('.js-productName').addClass('is-required');
			$('.js-productName .__label').addClass('__required').text('必須');
		} else {
			$('.js-productName').removeClass('is-required');
			$('.js-productName .__label').removeClass('__required').text('任意');	
		}
		// 購入ルート 
		if($('#route1').prop('checked') === true) {
			$('.js-retailer').removeClass('di_none');
		} else if($('#route2').prop('checked') === true) {
			$('.js-retailer').addClass('di_none');
			$('.js-retailer').find('input').val('');
		}
		// お問い合わせの種類
		if($('.js-modalItem').length) {
			let $inquiryType = $('input[name="inquiry_type"][type="hidden"]');
			if($inquiryType.val() !== '') {
				let selectedItem = $('.js-inquiry-btn[data-name="'+ $inquiryType.val() +'"]');
				let selectedItemName = selectedItem.attr('data-name');
				let selectedItemtxt = selectedItem.parents('tr').find('.js-inquiryType-itemTxt');
				$('.js-inquiryType-name').text(selectedItemName);
				if(selectedItemtxt.length) {
					$('.js-inquiryType-txt').text(selectedItemtxt.text());
				}
				$('.js-inquiryType-tbl').removeClass('di_none');
				$('.js-modalBtn').find('span').text('再選択');
			}
		}
	}
	const businessSelectChange = () => {
		// <入力画面>
		businessFormDataChange();
	
		$('.js-route-radio .mod-radio-input').on('change', (e) => {
			businessFormDataChange();
		});


		// <確認画面>
		if(location.pathname === '/contact/business/confirm/' ||
			location.pathname === '/contact/business/confirm/index.html') {

			// 選択肢によって「必須」「任意」出し分け =======
			let $inquiryType = $('input[name="inquiry_type"][type="hidden"]');
			let $route = $('input[name="inquiry_type"][type="hidden"]');

			if($inquiryType.length) {
				if($inquiryType.val() === '業務用食品') {
					$('.js-productName').addClass('is-required');
					$('.js-productName .__label').addClass('__required').text('必須');
				}
			}
			if($route.length) {
				if($route === 'あり') {
					$('.js-retailer').removeClass('di_none');	
				}
			}
		}
	};

	// 業務用商品
	const inquiryModal = () => {
		let scrollTopNow;
		if($('.js-modalBtn').length) {
			$('.js-modalBtn').on('click', (e) => {
				let $this = $(e.currentTarget);
				let thisModalHtml = $this.parent('div').next('.js-modalItem').prop('outerHTML');
				fixedOnContainer();

				$('.js-modal-base').append(thisModalHtml);
				$('.js-modal').addClass(a);
				$('.js-modal-overlay').on('click', () => {
					$('.js-modal').removeClass(a);
					$('.js-modal').find('.js-modalItem').remove();
					$('.js-modal-overlay').off();
					fixedOffContainer();
				});
				$('.js-modal-close').on('click', () => {
					$('.js-modal').removeClass(a);
					$('.js-modal').find('.js-modalItem').remove();
					$('.js-modal-close').off();
					fixedOffContainer();
				});
				$('.js-inquiry-btn').on('click', (e) => {
					let thisVal = $(e.currentTarget).attr('data-name');
					$('input[name="inquiry_type"]').val(thisVal);
					$('.js-inquiryType-name').text(thisVal);
					$('.js-modal').removeClass(a);
					$('.js-modal').find('.js-modalItem').remove();
					$('.js-inquiry-btn').off();
					$('.js-inquiryType-tbl').removeClass('di_none');

					let thisTxt = $(e.currentTarget).parents('tr').find('.js-inquiryType-itemTxt');
					if(thisTxt.length) {
					 	$('.js-inquiryType-txt').text(thisTxt.text());
					} else {
						$('.js-inquiryType-txt').text('');
					}
					$('.js-modalBtn').find('span').text('再選択');

					businessFormDataChange();

					fixedOffContainer();
				});
			});
		}

		const fixedOnContainer = () => {
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});
			$('body').addClass(f);
		};
		const fixedOffContainer = () => {
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
		};
	}



	// ==============================================================================
	selectChange();

	// 家庭用商品に関するお問い合わせフォーム
	if(location.pathname.indexOf('/inquiry/contact/household/') !== -1) {
		householdSelectChange();
		householdExpiryYear();
		householdBuyYear();
	}
	// 業務用（法人向け）商品に関するお問い合わせフォーム
	if(location.pathname.indexOf('/contact/business/') !== -1) {
		businessSelectChange();
		inquiryModal();
	}

})(window.jQuery, window.RIKEN);
